import { Component, computed, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LabelRequiredDirective } from '@shared/directives/label-required.directive';
import { TrierParPipe } from '@shared/pipes/trier-par.pipe';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmLabelImports } from '@spartan-ng/helm/label';
import { HlmSelectImports } from '@spartan-ng/helm/select';
import { HlmTextareaImports } from '@spartan-ng/helm/textarea';

import { TechniqueAnimationStore } from '../../../administration/technique-animation/store/technique-animation.store';
import { ModalitéStore } from '../../../modalités/store/modalité.store';
import { LieuType } from '../../models/lieu-type.enum';
import { AlerteComponent } from '@shared/components/alerte/alerte.component';
import { ReferentielStore } from '../../../administration/gestion-référentiels/store/referentiel.store';

@Component({
  selector: 'app-informations-pratiques',
  imports: [
    HlmFieldImports,
    HlmLabelImports,
    LabelRequiredDirective,
    ReactiveFormsModule,
    BrnSelectImports,
    HlmSelectImports,
    HlmInputImports,
    TrierParPipe,
    HlmTextareaImports,
    AlerteComponent,
  ],
  templateUrl: './informations-pratiques.component.html',
})
export class InformationsPratiquesComponent {
  readonly #référentielStore = inject(ReferentielStore);
  readonly #modalitéStore = inject(ModalitéStore);
  readonly #techniqueStore = inject(TechniqueAnimationStore);

  readonly form = input.required<FormGroup>();

  readonly referentiels = computed(() => this.#référentielStore.entities());
  readonly modalites = computed(() => this.#modalitéStore.entities());
  readonly techniquesAnimation = computed(() => this.#techniqueStore.entities());

  readonly lieux = Object.values(LieuType);

  compareWithId = (o1?: { id: string }, o2?: { id: string }) => o1?.id === o2?.id;
}
